module.exports = __webpack_public_path__ + "img/lucie-souhradova.bcda55c0.jpg";